;(function () {
	const SEKCJA_ID = 'o-mnie'

	if (sessionStorage.getItem('nafali-seen-2') === '1') return

	fetch('/admin/api2.php')
		.then(function (r) {
			return r.json()
		})
		.then(function (d) {
			if (d.enabled != 1) return

			// podmień obrazki z panelu admina
			const img = document.getElementById('nafali-plakat-img')
			if (img) {
				img.src = d.img_big
				const picture = img.closest('picture')
				if (picture) {
					const sources = picture.querySelectorAll('source')
					sources.forEach(function (source) {
						const media = source.getAttribute('media')
						if (media && media.includes('max-width')) {
							source.srcset = d.img_small
						} else {
							source.srcset = d.img_big
						}
					})
				}
			}

			const sekcja = document.getElementById(SEKCJA_ID)
			if (!sekcja) return

			const observer = new IntersectionObserver(
				function (entries) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							observer.disconnect()
							pokazPlakat()
						}
					})
				},
				{ threshold: 0.15 },
			)

			observer.observe(sekcja)

			function pokazPlakat() {
				const overlay = document.getElementById('nafali-plakat-overlay')
				if (!overlay) return
				overlay.style.display = 'flex'
				requestAnimationFrame(function () {
					overlay.classList.add('nafali-plakat--visible')
				})
			}

			const btn2 = document.getElementById('nafali-plakat-btn')
			if (btn2) {
				btn2.addEventListener('click', function () {
					sessionStorage.setItem('nafali-seen-2', '1')
					const overlay = document.getElementById('nafali-plakat-overlay')
					if (overlay) {
						overlay.classList.remove('nafali-plakat--visible')
						setTimeout(function () {
							overlay.style.display = 'none'
						}, 350)
					}
				})
			}
		})
		.catch(function () {})
})()
